import vRipple from "~/directives/VRipple"

export default defineNuxtPlugin(({vueApp}) => {
    vueApp.directive('ripple', vRipple)
    // console.log('v-ripple')
})